<template>
  <div>
    <fetching-data-spinner
      :error="error"
      :loading="loading"
      :loading-title="$t('queues.loading-settings')"
      enable-retry
      @retry="loadSettings"
    />
    <template v-if="!loading && !error">
      <slide-y-up-transition>
        <empty-card
          :table="isEnabled"
          :title="$t('queues.title')"
        >
          <template
            v-if="isEnabled"
            slot="title"
          >
            <b-button
              variant="outline-dark"
              :to="{name: 'admin:branches-management',query: { index: 6 }}"
            >
              {{ $t('queues.setting') }}
            </b-button>
          </template>
          <template v-if="isEnabled">
            <queues-table :no-queue="noQueue" />
          </template>
          <template v-else>
            <img
              style="margin-top: 10px"
              :src="require('@/assets/images/icons/queue/queue.png')"
            >
            <p class="mt-1">
              {{ $t('queues.enable') }}
            </p>
            <b-button
              variant="outline-dark"
              :to="{name: 'admin:branches-management',query: { index: 6 }}"
            >
              {{ $t('queues.enable-now') }}
            </b-button>
          </template>
        </empty-card>

      </slide-y-up-transition>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  BButton,
} from 'bootstrap-vue'
import FetchingDataSpinner from '@/@okmenu/components/utils/FetchingDataSpinner'
import ErrorHandler from '@/utils/error-handler'
import EmptyCard from '@/@okmenu/components/cards/EmptyCard'
import QueuesTable from '@/views/admin/management/queues/QueuesTable'

export default {
  name: 'QueuesWizard',
  components: {
    QueuesTable,
    EmptyCard,
    FetchingDataSpinner,
    BButton,
  },
  data() {
    return {
      loading: true,
      error: null,
    }
  },
  computed: {
    ...mapGetters({
      isEnabled: 'queues/isEnabled',
      noQueue: 'queues/noQueue',
    }),
  },
  watch: {
    currentBranchId() {
      this.loadSettings()
    },
  },
  async mounted() {
    await this.loadSettings()
  },
  methods: {
    async loadSettings() {
      this.loading = true
      this.error = null
      await this.$store.dispatch('queues/FETCH_DEPENDENCIES')
        .catch(e => {
          const { message } = ErrorHandler.getErrorDetails(e)
          this.error = message
        })
        .finally(() => { this.loading = false })
    },
  },
  metaInfo() {
    return {
      title: this.$t('queues.title'),
    }
  },
}
</script>
